import { TranslatedProduct } from "../types";

export const productsRU: TranslatedProduct = {
    "Orange": "Апельсин",
    "Watermelon": "Арбуз",
    "Avocado": "Авокадо",
    "Apricots": "Абрикос",
    "Pineapple": "Ананас",
    "Apples": "Яблоко",
    "Alica": "Алыча",
    "Pears": "Груша",
    "Eggplant": "Баклажан",
    "Grapes": "Виноград",
    "Grapefruit": "Грейпфрут",
    "Kiwi": "Киви",
    "Gooseberries": "Крыжовник",
    "Strawberry": "Клубника",
    "Mango": "Mанго",
    "Raspberries": "Малина",
    "Blueberries": "Черника",
    "Plums": "Cлива",
    "Lemon": "Лимон",
    "Mandarin": "Мандарин",
    "Olives": "Оливки",
    "Peaches": "Персик",
    "Raisins": "Изюм",
    "Figs (fresh)": "Инжир (свежий)",
    "Red currants": "Красная смородина",
    "Black currants": "Черная смородина",
    "Artichokes": "Артишоки",
    "Swede": "Брюква",
    "Zucchini": "Кабачок",
    "Cabbage": "Капуста",
    "Capers": "Каперсы",
    "Carrots": "Морковь",
    "Cucumber": "Огурец",
    "Garlic": "Чеснок",
    "Paprika": "Болгарский перец",
    "Potato starch": "Картофельный крахмал",
    "Potatoes": "Картофель",
    "Sago": "Саго",
    "Tapioca": "Тапиока",
    "Corn": "Кукуруза",
    "Corn starch": "Кукурузный крахмал",
    "Butter": "Сливочное масло",
    "Canola oil": "Рапсовое масло",
    "Sunflower seeds": "Се́мечки подсо́лнечника",
    "Sunflower oil": "Подсолнечное масло",
    "Walnut": "Грецкий орех",
    "Onion": "Лук репчатый",
    "Walnut oil": "Масло грецкого ореха",
    "Margarine": "Маргарин",
    "Bacon": "Сало",
    "Sugar": "Сахар",
    "Honey": "Мед",
    "Glucose-fructose syrup": "Глюкозно-фруктозный сироп",
    "Jam": "Варенье",
    "Berry syrup": "Ягодный сироп",
    "Cotton candy": "Сахарная вата",
    "Sorbet": "Сорбет",
    "Frozen juice": "Замороженный сок",
    "Apple juice": "Яблочный сок",
    "Coca-cola": "Coca-cola",
    "Coca-cola zero": "Coca-cola zero",
    "Pepsi": "Pepsi",
    "Milk": "Молоко",
    "Yogurt": "Йогурт",
    "Pumpkin": "Тыква",
    "Radish": "Редис",
    "Beets": "Свекла",
    "Celery": "Сельдерей",
    "Sweet cream": "Сливка",
    "Cottage cheese": "Творог",
    "Cheese": "Сыр",
    "Yolk": "Яичный желток",
    "Egg white": "Яичный белок",
    "Egg": "Яйцо",
    "Gelatin": "Желатин",
    "Black peppers": "Черный перец",
    "Peppermint": "Мята",
    "Red beans": "Фасоль",
    "Green peas": "Зеленый горошек",
    "Coconut milk": "Кокосовое молоко",
    "Turnip": "Редька",
    "Tofu": "Тофу",
    "Split peas": "Колотый горох",
    "Cornflakes": "Кукурузные хлопья",
    "Chips": "Картофельные чипсы",
    "Brussels sprouts": "Брюсельская капуста",
    "Cauliflower": "Цветная капуста",
    "Broccoli": "Брокколи",
    "Cooked spinach": "Вареный шпинат",
    "Spinach (fresh)": "Свежий шпинат",
    "Ice cream": "Мороженое",
    "Pasta": "Макароны",
    "Sour cream": "Сметана",
    "Milk chocolate": "Молочный шоколад",
    "Bread": "Хлеб",
    "Chicken": "Мясо курицы",
    "Pork": "Свинина",
    "Sausage": "Колбаса",
    "Hot dogs": "Сосиски",
    "Lentil": "Чечевица",
    "Sardels": "Сардельки",
    "Fish fingers": "Рыбные палочки",
    "Fishballs": "Рыбные котлеты",
    "Chocolate cheese": "Творожный сырок",
    "Curd cream": "Творожная масса",
    "Wheat flour": "Пшеничная мука",
    "Cookies" : "Печенье",
    "Oat flakes": "Овсяные хлопья",
    "Cashews": "Кешью",
    "Almonds": "Миндаль",
    "Coconut yogurtt": "Кокосовый йогурт",
    "Aspartame": "Аспартам",
    "Acesulfame potassium": "Ацесульфам калия",
    "Sorbitol": "Сорбитол",
    "Stevia": "Стевия",
    "Instant potato porridge": "Картофельное пюре быстрого приготовления",
    "Shrimps": "Креветки",
    "Beef": "Говядина",
    "Veal": "Телятина",
    "Smoked meat": "Копченое мясо",
    "Vegan jellies": "Желейные веганские конфеты",
    "Jelly candies with gelatin": "Желейные конфеты с желатином",
    "Dried apricots": "Курага",
    "Buckwheat": "Гречиха",
    "Asparagus": "Спаржа",
};

